@let appliedFilters = (filters$ | async) ?? [];
@let disabledFilters = (disabledFilters$ | async) ?? [];
@let hasAvailableFilter = (hasAvailableFilter$ | async) ?? true;
@let hasFiltersToApply = (hasFiltersToApply$ | async) ?? false;

<form
  [formGroup]="form"
  (ngSubmit)="submit()"
  class="form-sm button-sm"
  [class.hidden]="!showFilters"
>
  <mat-expansion-panel [expanded]="showFilters">
    <div class="flex flex-col gap-2 w-full mt-4">
      @for (control of filters.controls; track $index) {
        <div class="flex gap-2">
          <button
            type="button"
            mat-stroked-button
            class="square-button compact-button"
            (click)="remove($index)"
          >
            <mat-icon svgIcon="remix:System/delete-bin-line"></mat-icon>
          </button>

          <rms-filter-form
            [config]="config"
            [formControl]="control"
            [disabledFilters]="disabledFilters"
            [specialLabel]="specialLabel"
            [min]="min"
            (emitFormValue)="submit()"
          ></rms-filter-form>
        </div>
      }

      <div class="flex flex-col sm:flex-row gap-2">
        @if (hasAvailableFilter) {
          @if (filters.length === 0 && appliedFilters.length === 0) {
            <button
              type="button"
              mat-stroked-button
              class="button-sm"
              (click)="add()"
            >
              {{ "libs.filters.add-button" | translate }}
            </button>
          } @else {
            <button
              type="button"
              mat-stroked-button
              class="button-sm sm:hidden"
              (click)="add()"
            >
              {{ "libs.filters.add-button" | translate }}
            </button>

            <button
              type="button"
              mat-stroked-button
              class="square-button compact-button hidden sm:flex"
              (click)="add()"
            >
              <mat-icon svgIcon="remix:System/add-line"></mat-icon>
            </button>
          }
        }

        <div class="flex flex-col sm:flex-row-reverse gap-2">
          @if (appliedFilters.length > 0) {
            <button
              type="button"
              mat-stroked-button
              class="button-sm"
              (click)="clear()"
            >
              {{ "libs.filters.clear-button" | translate }}
            </button>
          }
          @if (hasFiltersToApply || appliedFilters.length > 0) {
            <button
              type="submit"
              mat-raised-button
              class="button-sm"
              color="primary"
            >
              {{ "libs.filters.apply-button" | translate }}
            </button>
          }
        </div>
      </div>
    </div>
  </mat-expansion-panel>
</form>

<rms-filters-chips
  [class.hidden]="showFilters"
  [filters]="appliedFilters"
  (removeFilter)="removeChip($event)"
></rms-filters-chips>
